module.exports = __webpack_public_path__ + "img/list.084e63c0.png";